/*
 * Tracking Event Search View
 * 
 * Angular module: trackerbase-app.views.tracking-event-search
 *
 */
import angular from "angular";
import uiRouter from "@uirouter/angularjs";

import Assert from "tbAssert";
import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

import TrackingEventSearchViewModuleConstants from "./Constants";
import TrackingEventSearchViewController from "./TrackingEventSearchViewController";
import AddTrackingEventSearchSetPageTitleHook from "./SetTrackingEventSearchPageTitleHook";

function TrackingEventSearchViewConfiguration($stateProvider) {
    
    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");
    
    $stateProvider
        .state(TrackingEventSearchViewModuleConstants.rootStateName, {
            url: "/tracking-event-search?{searchQuery:query}&{fromNavBar:bool}",
            template: TrackingEventSearchViewController.template,
            controller: TrackingEventSearchViewController,
            controllerAs: TrackingEventSearchViewController.controllerAs,
            data: {
                requiresLogin: true
            },
            params: {
                searchQuery: { dynamic: true},
                fromNavBar: {dynamic: true, squash: true}
            }
        });
}

TrackingEventSearchViewConfiguration.$inject = [
    "$stateProvider"
];

TrackingEventSearchViewConfiguration.dependencies = [
    uiRouter
];

const trackingEventSearchViewModuleDependencies = DependencyListBuilder([
    TrackingEventSearchViewConfiguration.dependencies,
    TrackingEventSearchViewController.dependencies,
    AddTrackingEventSearchSetPageTitleHook.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-event-search",
        trackingEventSearchViewModuleDependencies
    )
    .config(TrackingEventSearchViewConfiguration)
    .run(AddTrackingEventSearchSetPageTitleHook)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-search/TrackingEventSearch.js
// module id = gE6H
// module chunks = 1